export const OPEN_CONFIRMATION_BOX_MODAL = 'COMMON.OPEN_CONFIRMATION_BOX_MODAL';
export const RESOLVE_CONFIRMATION_MODAL = 'COMMON.RESOLVE_CONFIRMATION_MODAL';
export const REJECT_CONFIRMATION_MODAL = 'COMMON.REJECT_CONFIRMATION_MODAL';
